var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBussingNeeded = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#2BA18D",
  rx: 20
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10 25.143c0-.079.064-.143.143-.143h19.714c.079 0 .143.064.143.143A2.857 2.857 0 0 1 27.143 28H12.857C11.088 28 10 26.851 10 25.143ZM13 18.286c0-.158.128-.286.286-.286h13.428c.158 0 .286.128.286.286A5.714 5.714 0 0 1 21.286 24h-2.572A5.714 5.714 0 0 1 13 18.286ZM15 14.143c0-.079.064-.143.143-.143h9.714c.079 0 .143.064.143.143A2.857 2.857 0 0 1 22.143 17h-4.286A2.857 2.857 0 0 1 15 14.143Z"
})));
SvgBussingNeeded.viewBox = '0 0 40 40';
const ForwardRef = /*#__PURE__*/forwardRef(SvgBussingNeeded);
export default ForwardRef;